document.addEventListener("DOMContentLoaded", () => {

        const ANCHOR_PEEK_OFFSET = 75;

        function canHandleAsScrollAnchor(path, hash) {
            if (!hash) {
                return false;
            }

            if (path.includes("/pages/faqs-order")) {
                return document.querySelector(`[href="#${hash}"]`) !== null;
            }

            return document.getElementById(hash) !== null;
        }

        function getStickyHeaderHeight() {
            const stickyHeader = document.querySelector(".sticky-header.show");
            if (stickyHeader) {
                return stickyHeader.offsetHeight;
            }

            const siteHeader = document.querySelector(".site-header:not(.sticky-header)");
            if (!siteHeader) {
                return 0;
            }

            const position = window.getComputedStyle(siteHeader).position;
            if (position === "fixed" || position === "sticky") {
                return siteHeader.offsetHeight;
            }

            return 0;
        }

        function scrollToAnchor(hash) {
            if (!hash) {
                return false;
            }

            const target = document.getElementById(hash);
            if (!target) {
                return false;
            }

            const offset = getStickyHeaderHeight() + ANCHOR_PEEK_OFFSET;
            const y = target.getBoundingClientRect().top + window.pageYOffset - offset;

            window.scrollTo({
                top: Math.max(0, y),
                behavior: "smooth"
            });

            return true;
        }

        function handleFaqsOrderAnchor(hash) {
            document.querySelector(`[href="#${hash}"]`)?.click();
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }

        function handleAnchorNavigation(path, hash, updateHistory) {
            if (!canHandleAsScrollAnchor(path, hash)) {
                return;
            }

            if (path.includes("/pages/faqs-order")) {
                handleFaqsOrderAnchor(hash);
                return;
            }

            if (scrollToAnchor(hash) && updateHistory) {
                history.pushState(null, "", `#${hash}`);
            }
        }

        if (window.location.hash.length > 1) {
            const initialPath = window.location.pathname;
            const initialHash = window.location.hash.substring(1);

            setTimeout(() => {
                handleAnchorNavigation(initialPath, initialHash, false);
            }, 100);
        }

        document.body.addEventListener("click", function (e) {
            const anchor = e.target.closest("a");
            if (!anchor || e.target.closest(".sidebar-navigation a")) {
                return;
            }

            const href = anchor.getAttribute("href");
            if (!href || !href.includes("#")) {
                return;
            }

            const hashIndex = href.indexOf("#");
            const path = href.slice(0, hashIndex);
            const hash = href.slice(hashIndex + 1);
            if (!hash) {
                return;
            }

            const isSamePage = href.startsWith("#") || path === "" || path === window.location.pathname;
            if (!isSamePage) {
                return;
            }

            const pagePath = path || window.location.pathname;

            if (!canHandleAsScrollAnchor(pagePath, hash)) {
                return;
            }

            e.preventDefault();
            handleAnchorNavigation(pagePath, hash, true);
        });

        function checkRegisterFields() {
           
            setTimeout(()=>{
                const name = document.querySelector('[name="first_name"]').value             
                const lastName = document.querySelector('[name="last_name"]').value;
                const address = document.querySelector('[name="default_address.country"]').value;
                const email = document.querySelector('[name="email"]').value; 
                const privacy = document.querySelector('[name="privacy_checkbox"]').value;

                
                if(name && name != "" && lastName && lastName != "" && address && address !="" && email && email != "" && privacy && privacy != "" && privacy != "false") {
                   
                    document.querySelector("button.cf-submit-form.cf-button.btn.button").removeAttribute("disabled");
                }
            }, 1000)
                
        }

         if(document.querySelector("#create_customer")) {
            const registerForm = document.querySelector("#create_customer");
            // Also trigger when the form is focused (helps for late autofill)
            registerForm.addEventListener('focusin', checkRegisterFields);

            // After successful registration Helium injects .cf-verify-email-message; scroll so the banner is visible from the top
            (function initRegisterSuccessScrollToTop() {
                let didScroll = false;

                function tryScrollToTop() {
                    if (didScroll || !registerForm.querySelector(".cf-verify-email-message")) return;
                    didScroll = true;
                    observer.disconnect();
                    window.scrollTo({ top: 0, behavior: "smooth" });
                }

                const observer = new MutationObserver(tryScrollToTop);
                tryScrollToTop();
                observer.observe(registerForm, { childList: true, subtree: true });
            })();
         }
})